import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CSLReferenceMeta } from '../../../../../../../libs/cite/src/public-api';

@Component({
  selector: 'sfo-reference-source-badge',
  templateUrl: './reference-source-badge.component.html',
  styleUrls: ['./reference-source-badge.component.scss'],
  standalone: true,
  imports: [MatIconModule, MatTooltipModule],
})
export class ReferenceSourceBadgeComponent {
  source = input<CSLReferenceMeta['source'] | undefined>(undefined);
  reviewed = input<boolean | undefined>(false);
}
